import { render, staticRenderFns } from "./ProjectManagers.vue?vue&type=template&id=5b81444a&"
import script from "./ProjectManagers.vue?vue&type=script&lang=js&"
export * from "./ProjectManagers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectManagers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports